/* YESSKIN · Secciones "uz-*" (landing estilo Uruzen) — interacciones sin dependencias. */
(function () {
  'use strict';
  if (window.__uzLanding) return;
  window.__uzLanding = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------------- aparición al hacer scroll ---------------- */
  var revealIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function scanReveal(root) {
    $$('[data-uz-reveal]:not(.is-in)', root).forEach(function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------------- ir a la compra ---------------- */
  function buyTarget() {
    return $('[data-uz-form]') || $('[data-uv-form]') || $('.pd-offers') || $('form[action*="/cart/add"]');
  }
  function scrollToEl(el, off) {
    if (!el) return false;
    var t = el.getBoundingClientRect().top + window.pageYOffset - (off || 84);
    window.scrollTo({ top: t, behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-uz-buy]');
    if (a) { if (scrollToEl(buyTarget())) e.preventDefault(); return; }
    var g = e.target.closest && e.target.closest('[data-uz-goto]');
    if (g) { if (scrollToEl($(g.getAttribute('data-uz-goto')), 70)) e.preventDefault(); }
  });

  /* ---------------- carrusel con scroll-snap ---------------- */
  function initRail(root) {
    if (root.__uz) return; root.__uz = true;
    var track = $('[data-uz-rail-track]', root); if (!track) return;
    var slides = $$('[data-uz-slide]', track);
    var prev = $('[data-uz-rail-prev]', root), next = $('[data-uz-rail-next]', root);
    function step() { var s = slides[0]; return s ? s.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function edges() {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(edges); }, { passive: true });
    window.addEventListener('resize', edges);
    edges();
    var every = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    if (every && !reduce && slides.length > 1) {
      var paused = false, visible = false;
      if (hasIO) { root.__io = new IntersectionObserver(function (en) { visible = en[en.length - 1].isIntersecting; }, { threshold: 0.35 }); root.__io.observe(root); } else visible = true;
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin', 'wheel'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      root.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () { if (!paused && visible && !document.hidden) go(1); }, every);
    }
  }

  /* ---------------- videos: reproducir solo a la vista ---------------- */
  var vidIO = hasIO ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.45 }) : null;
  function initVideo(v) {
    if (v.__uz) return; v.__uz = true;
    v.muted = true;
    if (vidIO && !reduce) vidIO.observe(v);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-uz-sound]');
    if (!b) return;
    var v = b.parentNode.querySelector('video'); if (!v) return;
    var on = v.muted;
    $$('[data-uz-video]').forEach(function (o) { if (o !== v) { o.muted = true; var ob = o.parentNode.querySelector('[data-uz-sound]'); if (ob) ob.classList.remove('is-on'); } });
    v.muted = !on; b.classList.toggle('is-on', on);
    if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  /* ---------------- línea de tiempo ---------------- */
  var tls = [], ticking = false;
  function paintTimelines() {
    ticking = false;
    var vh = window.innerHeight, mark = vh * 0.62;
    tls.forEach(function (tl) {
      var line = tl.__line, fill = tl.__fill; if (!line || !fill) return;
      var r = line.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (mark - r.top) / (r.height || 1)));
      fill.style.setProperty('--p', p.toFixed(3));
      tl.__steps.forEach(function (st) {
        var d = st.__dot.getBoundingClientRect();
        st.classList.toggle('is-on', d.top + d.height / 2 <= mark + 6);
      });
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paintTimelines); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function initTimeline(tl) {
    if (tl.__uz) return; tl.__uz = true;
    tl.__line = $('.uz-tl__line', tl); tl.__fill = $('[data-uz-tl-fill]', tl);
    tl.__steps = $$('[data-uz-tl-step]', tl);
    tl.__steps.forEach(function (st) { st.__dot = $('.uz-tl__dot', st); });
    if (reduce) { tl.__steps.forEach(function (st) { st.classList.add('is-on'); }); if (tl.__fill) tl.__fill.style.setProperty('--p', 1); return; }
    tls.push(tl); onScroll();
  }

  /* ---------------- acordeones ---------------- */
  function initAcc(root) {
    if (root.__uz) return; root.__uz = true;
    $$('[data-uz-acc-item]', root).forEach(function (item) {
      var btn = $('[data-uz-acc-btn]', item);
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        $$('[data-uz-acc-item].is-open', root).forEach(function (o) { if (o !== item) { o.classList.remove('is-open'); $('[data-uz-acc-btn]', o).setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- reseñas: ver más ---------------- */
  function initMore(sec) {
    if (sec.__uz) return; sec.__uz = true;
    var grid = $('[data-uz-more]', sec), btn = $('[data-uz-more-btn]', sec);
    if (!grid || !btn) return;
    btn.addEventListener('click', function () {
      var open = !grid.classList.contains('is-open');
      grid.classList.toggle('is-open', open);
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) scrollToEl(grid, 100);
    });
  }

  /* ---------------- galería + miniaturas ---------------- */
  function initGallery(gal) {
    if (gal.__uz) return; gal.__uz = true;
    var track = $('[data-uz-gal-track]', gal); if (!track) return;
    var slides = $$('[data-uz-gal-slide]', track);
    function idx() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    var p = $('[data-uz-gal-prev]', gal), n = $('[data-uz-gal-next]', gal);
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    gal.__go = go;
  }
  function initThumbs(th) {
    if (th.__uz) return; th.__uz = true;
    var host = th.parentNode;
    var track = $('[data-uz-gal-track]', host) || $('[data-uv-gal-track]', host); if (!track) return;
    var slides = $$('[data-uz-gal-slide], [data-uv-gal-slide]', track);
    var btns = $$('[data-uz-thumb]', th);
    function slideLeft(i) { var base = slides[0].offsetLeft; return slides[i].offsetLeft - base; }
    function current() {
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs(slideLeft(i) - track.scrollLeft); if (d < bestD) { bestD = d; best = i; } });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = slides.length - 1;
      return best;
    }
    var last = -1;
    function mark() {
      var i = current(); if (i === last) return; last = i;
      btns.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      var b = btns[i]; if (b) { var l = b.offsetLeft - (th.clientWidth - b.clientWidth) / 2; th.scrollTo({ left: Math.max(0, l), behavior: reduce ? 'auto' : 'smooth' }); }
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { if (slides[k]) track.scrollTo({ left: slideLeft(k), behavior: reduce ? 'auto' : 'smooth' }); }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  /* ---------------- mini reseñas rotativas ---------------- */
  function initMini(root) {
    if (root.__uz) return; root.__uz = true;
    var items = $$('[data-uz-mini-item]', root); if (items.length < 2) return;
    var i = 0, paused = false;
    function show(n) { i = (n + items.length) % items.length; items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); }); }
    var pv = $('[data-uz-mini-prev]', root), nx = $('[data-uz-mini-next]', root);
    if (pv) pv.addEventListener('click', function () { paused = true; show(i - 1); });
    if (nx) nx.addEventListener('click', function () { paused = true; show(i + 1); });
    if (!reduce) setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, 4200);
  }

  /* ---------------- producto (uz-main) ---------------- */
  function directCheckout(items) {
    var map = {}, order = [];
    items.forEach(function (it) { var id = String(it.id); if (!/^\d+$/.test(id)) return; if (!map[id]) { map[id] = 0; order.push(id); } map[id] += parseInt(it.quantity, 10) || 1; });
    if (order.length) window.location.href = '/cart/' + order.map(function (id) { return id + ':' + map[id]; }).join(',');
  }
  function initProduct(root) {
    if (root.__uz) return; root.__uz = true;
    var form = $('[data-uz-form]', root); if (!form) return;
    var idInput = $('[data-uz-id]', form), qtyInput = $('[data-uz-qty]', form);
    var offers = $$('[data-uz-offer]', form), btn = $('[data-uz-atc]', form);
    var applied = $('[data-uz-applied]', root), up = $('[data-uz-upsell]', form);
    var gift = '';

    function select(o, silent) {
      offers.forEach(function (x) { var on = x === o; x.classList.toggle('is-selected', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      idInput.value = o.getAttribute('data-variant');
      qtyInput.value = o.getAttribute('data-qty') || 1;
      gift = o.getAttribute('data-gift') || '';
      var ok = o.getAttribute('data-available') !== 'false';
      btn.disabled = !ok;
      var lab = $('.uz-atc__label', btn);
      if (lab) lab.textContent = ok ? lab.getAttribute('data-label') : (btn.getAttribute('data-soldout') || 'Agotado');
      if (applied) {
        var sv = o.getAttribute('data-save') === '1';
        applied.hidden = !sv;
        if (sv && !silent && !reduce) { applied.classList.remove('is-pop'); void applied.offsetWidth; applied.classList.add('is-pop'); }
      }
    }
    offers.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); var k = offers.indexOf(o) + (e.key === 'ArrowDown' ? 1 : -1); var nx = offers[(k + offers.length) % offers.length]; select(nx); nx.focus(); }
      });
    });
    var initial = offers.filter(function (o) { return o.classList.contains('is-selected'); })[0] || offers[0];
    if (initial) select(initial, true);

    if (up) {
      var toggleUp = function () { var on = !up.classList.contains('is-on'); up.classList.toggle('is-on', on); up.setAttribute('aria-checked', on ? 'true' : 'false'); };
      up.addEventListener('click', toggleUp);
      up.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleUp(); } });
    }

    function add() {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }];
      if (up && up.classList.contains('is-on')) items.push({ id: parseInt(up.getAttribute('data-variant'), 10), quantity: 1 });
      if (/^\d+$/.test(gift)) items.push({ id: parseInt(gift, 10), quantity: 1, properties: { '_regalo': 'Yesskin' } });
      if (root.getAttribute('data-checkout') === 'true') { directCheckout(items); return; }
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok || res.j.status) { alert(res.j.description || res.j.message || 'No se pudo agregar al carrito.'); return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'uz-landing', cartData: res.j }); } catch (e) {} }
          if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
            try { drawer.classList.remove('is-empty'); drawer.renderContents(res.j); return; } catch (e) {}
          }
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { btn.classList.remove('is-loading'); form.submit(); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }

  /* ---------------- barra fija inferior ---------------- */
  function initBar(bar) {
    if (bar.__uz) return; bar.__uz = true;
    var anchor = $('[data-uz-atc-main]') || $('[data-uv-atc-main]');
    var form = buyTarget();
    if (!anchor) { bar.classList.add('is-on'); document.body.classList.add('uz-has-bar'); bar.setAttribute('aria-hidden', 'false'); return; }
    var raf = 0, last = null;
    function paint() {
      raf = 0;
      var vh = window.innerHeight;
      var a = anchor.getBoundingClientRect();
      var passed = a.bottom < 0;
      var formVisible = false;
      if (form) { var f = form.getBoundingClientRect(); var vis = Math.min(f.bottom, vh) - Math.max(f.top, 0); formVisible = vis > Math.min(f.height, vh) * 0.2; }
      var on = passed && !formVisible;
      document.body.classList.toggle('uz-has-bar', passed);
      if (on === last) return; last = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a, button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
    /* si hay barra pd/uv propia, la nuestra manda */
    $$('[data-uv-sticky]').forEach(function (s) { s.style.display = 'none'; });
  }

  /* ---------------- init ---------------- */
  function scan(root) {
    root = root || document;
    scanReveal(root);
    $$('[data-uz-rail]', root).forEach(initRail);
    $$('[data-uz-video]', root).forEach(initVideo);
    $$('[data-uz-tl]', root).forEach(initTimeline);
    $$('[data-uz-acc]', root).forEach(initAcc);
    $$('[data-uz-reviews]', root).forEach(initMore);
    $$('[data-uz-gal]', root).forEach(initGallery);
    $$('[data-uz-thumbs]', root).forEach(initThumbs);
    $$('[data-uz-mini]', root).forEach(initMini);
    $$('[data-uz-product]', root).forEach(initProduct);
    $$('[data-uz-bar]', root).forEach(initBar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var it = e.target;
    if (it.matches && it.matches('[data-uz-acc-item]') && !it.classList.contains('is-open')) { var b = $('[data-uz-acc-btn]', it); if (b) b.click(); }
    if (it.matches && it.matches('[data-uz-offer]')) it.click();
    if (it.matches && it.matches('[data-uz-more-item].is-extra')) { var sec = it.closest('[data-uz-reviews]'); var mb = sec && $('[data-uz-more-btn]', sec); var g = sec && $('[data-uz-more]', sec); if (mb && g && !g.classList.contains('is-open')) mb.click(); }
    $$('[data-uz-reveal]', it).concat([it]).forEach(function (el) { if (el.classList) el.classList.add('is-in'); });
  });
})();
